<form clrForm [formGroup]="searchForm">
  <div class="clr-row">
    <subs-date
      controlName="dateFrom"
      label="Date From"
      labelLength="4"
      class="clr-col"
      errorMessage="Required field"
    >
    </subs-date>
    <subs-date
      controlName="dateThru"
      label="Date Thru"
      labelLength="4"
      class="clr-col"
      errorMessage="Required field"
    >
    </subs-date>
  </div>
  <div style="margin-top: 24px">
    <subs-alert [alertBehavior]="alertSubject$"> </subs-alert>
    <button
      type="button"
      class="btn btn-primary"
      [clrLoading]="submitState | async"
      (click)="search()"
      data-test-id="search-btn"
      [disabled]="!searchForm.valid"
    >
      Submit
    </button>

    <button
      type="button"
      class="btn btn-outline"
      (click)="clear()"
      data-test-id="clear-btn"
    >
      Clear
    </button>
  </div>
</form>
